import { useAuth } from "../contexts/AuthContext";

export const BETA_EXPORT_TOOLTIP = "Export CSV - Not Available in Beta";

export default function CsvExportButton({
  as: Button = "button", disabled = false, onClick, title = "Export CSV", style, ...props
}) {
  const { currentUser, loadingUser } = useAuth();
  const restricted = loadingUser || !currentUser?.is_admin;
  const tooltip = restricted ? BETA_EXPORT_TOOLTIP : title;

  return <Button
    {...props}
    type="button"
    disabled={disabled || restricted}
    aria-disabled={disabled || restricted}
    aria-label={restricted ? tooltip : props["aria-label"] || title}
    title={tooltip}
    data-tooltip={restricted ? tooltip : props["data-tooltip"]}
    onClick={restricted || disabled ? undefined : onClick}
    style={{ ...style, ...(restricted ? { cursor: "not-allowed" } : {}) }}
  />;
}
